// extracted by mini-css-extract-plugin
module.exports = {"column__en":"SectionTitle--column__en--VGD-M","column__jp":"SectionTitle--column__jp--39pb6"};